module.exports = __webpack_public_path__ + "static/media/download.7e58c793.svg";